/** Display helpers shared by the web and mobile apps (Serbian, Latin script). */
export const time = (iso) => new Date(iso).toLocaleTimeString('sr-Latn-RS', { hour: '2-digit', minute: '2-digit' });
export const usd = (value) => value < 0.01 && value > 0 ? '< $0,01' : `$${value.toFixed(2).replace('.', ',')}`;
export const statusLabel = {
    done: 'Urađeno',
    failed: 'Nije uspelo',
    denied: 'Odbijeno',
    skipped: 'Preskočeno',
    pending: 'U toku',
    waiting_confirm: 'Čeka potvrdu',
};
export const levelLabel = {
    allow: 'Sme',
    ask: 'Pita',
    deny: 'Ne sme',
};
export const nextLevel = (level) => level === 'allow' ? 'ask' : level === 'ask' ? 'deny' : 'allow';
/** "34 / 64" or just "34" when the server doesn't report a limit. */
export const playerCount = (count, max) => max ? `${count} / ${max}` : String(count);
export function greeting(date = new Date()) {
    const h = date.getHours();
    if (h < 5)
        return 'Kasno je, ali tu sam.';
    if (h < 12)
        return 'Dobro jutro. Šta radimo danas?';
    if (h < 18)
        return 'Ćao. Reci šta ti treba.';
    return 'Dobro veče. Spremna sam.';
}
//# sourceMappingURL=format.js.map